import script from "./Socks4Proxies.vue?vue&type=script&setup=true&lang=ts"
export * from "./Socks4Proxies.vue?vue&type=script&setup=true&lang=ts"

import "./Socks4Proxies.vue?vue&type=style&index=0&id=6c0d8d98&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0d8d98"]])

export default __exports__